import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import style from './BlinkingLight.module.less';

import starWhite from './assets/starWhite.png';
import starBlue from './assets/heart_blue.png';
import starRed from './assets/heart_red.png';
import starYellow from './assets/heart_yellow.png';
import starGreen from './assets/heart_green.png';

export const CORRECT_COMBINATION = ['yellow', 'green', 'blue', 'yellow', 'blue', 'yellow'];

const LONG_BLINK = 900;
const LONG_PAUSE = 900;

function getStar(light: string, solved: number) {
  if (solved === 2) {
    return starRed;
  }
  if (solved === 1) {
    return starWhite;
  }

  switch (light) {
    case 'yellow':
      return starYellow;
    case 'green':
      return starGreen;
    case 'blue':
      return starBlue;
    case 'red':
      return starRed;
    default:
      return starWhite;
  }
}

function doBlink(setLight: (l: string) => void) {
  return new Promise((resolve) => {
    CORRECT_COMBINATION.forEach((light, i) => {
      const isLast = i + 1 === CORRECT_COMBINATION.length;
      const blinkTime = LONG_BLINK;
      const begin = i * LONG_BLINK;

      // enable light
      setTimeout(() => setLight(light), begin);

      if (isLast) {
        setTimeout(() => setLight('white'), begin + blinkTime);
        setTimeout(() => resolve(undefined), begin + blinkTime + LONG_PAUSE);
      }
    });
  });
}

interface BlinkingLightProps {
  solved: number;
}

export const BlinkingLight = ({ solved }: BlinkingLightProps) => {
  const [light, setLight] = useState('white');

  useEffect(() => {
    (async function rememberToBlink() {
      await doBlink(setLight);
      rememberToBlink();
    }());
  }, []);

  return (
    <img
      className={classnames(style.blinking, style.noDrag)}
      src={getStar(light, solved)}
      alt="Star"
    />
  );
};
